<template>
    <v-card elevation="8" class="ma-5 mt-10" style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-container fluid>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md12 ma-4>
                    <h2><b>Análise de mortalidade por período de fechamento</b></h2>
                </v-flex>
            </v-layout>
            <v-form v-model="isFormValid" ref="form">
                <v-layout row wrap justify-start class="pl-2">
                    <v-flex class="item" lg3 md3 sm6 xs11 pa-1>
                        <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="csTipoUEP" :items="tiposUnidadesExploracao"
                            color="primary" item-text="dsTipoUnidadeExploracao" item-value="csTipoUnidadeExploracao" label="Tipo de Unidade Exploração"
                            no-data-text="Nenhum registro" outlined clearable>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex class="item" lg2 md2 sm6 xs11 pa-1>
                        <v-autocomplete
                            label="Extensionista"
                            outlined
                            clearable
                            hide-details
                            v-model="cdResponsavelTecnico"
                            :items="technicalManagers"
                            item-text="nmPessoa"
                            item-value="idResponsavelTecnico"
                            :loading="loadingTechnicalManagers"
                        />
                    </v-flex>
                    <v-flex class="item" lg2 md2 sm6 xs11 pa-1>
                        <SelectMonth label="Mês de fechamento" :readonly="true" v-model="dtMesFechamento"></SelectMonth>
                    </v-flex>
                    <v-flex class="item" lg2 md2 sm6 xs11 pa-1>
                        <v-row align="start" justify="start">
                            <v-btn dark rounded color="#FF5252" style="margin: 10px; margin-left: 15px;" @click="removeAllComparativos">
                                Remover gráficos comparativos
                                <v-icon small right>fas fa-trash-alt</v-icon>
                            </v-btn>
                        </v-row>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-row v-for="(dataGraph, idx) in listRegistrosExtensionista" :key="idx">
                <v-layout row wrap justify-start class="pl-2">
                    <v-subheader>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        depressed
                                        icon
                                        x-small
                                        color="#ff5252"
                                        @click.native="removeAllItemSelection(idx)"
                                        class="mr-2 card-actions__btn delete"
                                >
                                    <v-icon x-small color="white">fas fa-trash</v-icon>
                                </v-btn>
                            </template>
                            <span>Remover gráfico</span>
                        </v-tooltip>
                        {{ dataGraph.nmResponsavelTecnico }}
                    </v-subheader>
                    <v-flex class="item" lg7 md7 sm7 xs11 pa-1>
                        <v-container class="py-0">
                            <v-row align="center" justify="start">
                                <v-col v-for="(selection, i) in dataGraph.selected" :key="selection.text" class="shrink" style="padding: 3px;">
                                    <v-chip close @click:close="removeItemSelection(idx, i)" >
                                        {{ selection.text }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-flex>   
                    <v-flex xs12 md12 sm12 lg12 >
                        <GraficoMortalidadePeriodoFechamento v-if="exibeGrafico" :values="dataGraph.registrosMortalidadeGrafico" :itemTabelaMetaMortalidade="listaTabelaMortalidadeTipoUep"/>
                    </v-flex>
                    <v-divider v-if="listRegistrosExtensionista.length != idx +1" style="margin-right: 5px; margin-bottom: 15px; border-color: #0000003d;"></v-divider>
                </v-layout>
            </v-row>
        </v-container>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @return="voltar" :canSave="false" :canDelete="false"/>
            </v-flex>
        </v-layout>
        <AppLoaderBlockCard :overlay="isLoading"/>
    </v-card>
</template>

<script>

import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'
import SelectMonth from '@/components/general/SelectMonth.vue'
import GraficoMortalidadePeriodoFechamento from "@/components/analises/GraficoMortalidadePeriodoFechamento.vue";
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import { dateLocalToIso } from '@/filters/utils'
import { campoSelectObrigatorio, validarDataFutura } from '@/filters/rules'
import axios from "axios"
import moment from 'moment'

export default {
    name: 'AnaliseMortalidadePeriodoFechamento',
    components: {
        AppLoaderBlockCard,
        SelectMonth,
        AppMainActionsButtonsForm,
        GraficoMortalidadePeriodoFechamento,
    },
    data() {
        return {
            isLoading: false,
            isFormValid: false,
            exibeGrafico: false,
            dtMesFechamento: null,
            selected: [],
            csTipoUEP: '',
            listRegistrosExtensionista: [],
            registrosMortalidadeGrafico: {},
            listaTabelaMortalidadeTipoUep: {},
            cdResponsavelTecnico: 0,
            technicalManagers: [],
            loadingTechnicalManagers: false
        }
    },
    computed: {
        tiposUnidadesExploracao () {
            return this.$store.state.tiposUnidadesExploracaoSemUpl
        },
        selections () {
            const selections = []

            for (const selection of this.selected) {
                selections.push(selection)
            }
            this.dtMesFechamento = null
            return selections
        },
        tabelasMetaMortalidade() {
            return this.$store.state.tabelasMetaMortalidade
        },
    },
    methods: {
    	  validarDataFutura,
        dateLocalToIso,
        campoSelectObrigatorio,
        listTechnicalManagers() {
			this.loadingTechnicalManagers = true;

			this.$axios.get('responsavel-tecnico/responsavel_tecnico_ativo/')
				.then(res => {
					if (!res.data) return;
					if (!res.data[0]) return;
					if (!res.data[0].data) return;

					this.technicalManagers = res.data[0].data;
				})
				.catch(error => {
					this.$store.commit('setSnack', {
						type: 'error',
						msg: error
					});
				})
				.finally(() => (this.loadingTechnicalManagers = false));
		},
        removeAllComparativos(){
            this.listRegistrosExtensionista = []
            this.cdResponsavelTecnico = 0
        },
        removeAllItemSelection(itemResponsavel) {
            var context = this
            context.isLoading = true
            let respTecnico = context.listRegistrosExtensionista[itemResponsavel]
            context.listRegistrosExtensionista.splice(itemResponsavel, 1)
            if (context.listRegistrosExtensionista.length == 0)
            {
                context.exibeGrafico = false
                context.isLoading = false
            }
            else
            {
                context.listRegistrosExtensionista.forEach(function(responsavel) {
                    responsavel.registrosMortalidadeGrafico = {}
                    responsavel.selected.forEach(function(date) {
                        context.loadMortalidades(responsavel.cdResponsavelTecnico, date)
                    })
                })
            }
        },
        removeItemSelection(itemResponsavel, item) {
            var context = this
            context.isLoading = true
            let respTecnico = context.listRegistrosExtensionista[itemResponsavel]
            respTecnico.selected.splice(item, 1)
            respTecnico.registrosMortalidadeGrafico = {}
            if (respTecnico.selected.length > 0)
            {
                respTecnico.selected.forEach(function(date) {
                    context.loadMortalidades(respTecnico.cdResponsavelTecnico, date)
                })
            }
            else
            {
                context.listRegistrosExtensionista.splice(itemResponsavel, 1)
                if (context.listRegistrosExtensionista.length == 0)
                {
                    context.exibeGrafico = false
                    context.isLoading = false
                }
                else
                {
                    context.listRegistrosExtensionista.forEach(function(responsavel) {
                        responsavel.registrosMortalidadeGrafico = {}
                        responsavel.selected.forEach(function(date) {
                            context.loadMortalidades(responsavel.cdResponsavelTecnico, date)
                        })
                    })
                }
            }
        },
        selectedMonthChange(monthSelected) {
            this.isLoading = true
            if (this.csTipoUEP != '')
            {
                var itemTabela = this.tabelasMetaMortalidade.find( i => i.sgTipoUep == this.csTipoUEP)
                if (itemTabela)
                {
                    this.listaTabelaMortalidadeTipoUep = itemTabela
                }
                
                var dataInicioFormatada = null
                var dataFimFormatada = null
                var month = parseInt(monthSelected.split('/')[0])
                var year = parseInt(monthSelected.split('/')[1])
                var dataInicio = new Date(year, month -1, 1)
                dataInicioFormatada = dataInicio.toISOString().split('T')[0]
                var dataFim = new Date(year, month, 0)
                dataFimFormatada = dataFim.toISOString().split('T')[0]
                
                var dataAtual = new Date()
                var monthAtual = dataAtual.getMonth() + 1
                var yearAtual = dataAtual.getFullYear()

                if (validarDataFutura(dataInicio) === true)
                {
                    var context = this
                    var newItemSelected = {
                        text: monthSelected,
                        dtInicial: dataInicioFormatada,
                        dtFinal: dataFimFormatada,
                    }
                    if (context.cdResponsavelTecnico) {
                        let respTecnico = context.listRegistrosExtensionista.find(x => x.cdResponsavelTecnico == context.cdResponsavelTecnico)
                        if (respTecnico) {
                            if (respTecnico.selected.find(x => x.text == newItemSelected.text) == undefined) {
                                respTecnico.selected.push(newItemSelected)
                                this.loadMortalidades(respTecnico.cdResponsavelTecnico, newItemSelected)
                            }
                        }
                        else {
                            let newRespTecnico = {
                                cdResponsavelTecnico: context.cdResponsavelTecnico,
                                nmResponsavelTecnico: context.technicalManagers.find(x => x.idResponsavelTecnico == context.cdResponsavelTecnico).nmPessoa,
                                registrosMortalidadeGrafico: {},
                                selected: []
                            }
                            context.listRegistrosExtensionista.push(newRespTecnico)
                            if (newRespTecnico.selected.find(x => x.text == newItemSelected.text) == undefined) {
                                newRespTecnico.selected.push(newItemSelected)
                                this.loadMortalidades(newRespTecnico.cdResponsavelTecnico, newItemSelected)
                            }
                        }
                    }
                    else {
                        let respTecnico = context.listRegistrosExtensionista.find(x => x.cdResponsavelTecnico == 0)
                        if (respTecnico) {
                            if (respTecnico.selected.find(x => x.text == newItemSelected.text) == undefined) {
                                respTecnico.selected.push(newItemSelected)
                                this.loadMortalidades(respTecnico.cdResponsavelTecnico, newItemSelected)
                            }
                        }
                        else {
                            let newRespTecnico = {
                                cdResponsavelTecnico: 0,
                                nmResponsavelTecnico: 'Sem Extensionista',
                                registrosMortalidadeGrafico: {},
                                selected: []
                            }
                            newRespTecnico.selected.push(newItemSelected)
                            this.listRegistrosExtensionista.push(newRespTecnico)
                            this.loadMortalidades(newRespTecnico.cdResponsavelTecnico, newItemSelected)
                        }
                    }
                    this.dtMesFechamento = null
                } else {
                    this.dtMesFechamento = null
                    this.isLoading = false
                    this.$store.commit('setSnack', {type: 'error', msg : "Mês de fechamento não pode ser superior ao mês atual!"})
                }
            }
            else
            {
                this.dtMesFechamento = null
                this.isLoading = false
                this.$refs.form.validate()
            }
        },
        async loadMortalidades(cdResponsavelTecnico, item) {
            if (this.$refs.form.validate() && item)
            {
                var context = this
                context.exibeGrafico = false
                try 
                {
                    let params = {
                        dtInicio: item.dtInicial,
                        csTipoUep: this.csTipoUEP ? this.csTipoUEP : null,
                        dtFim: item.dtFinal,
                        cdResponsavelTecnico: cdResponsavelTecnico
                    }
                    let response = await axios.get("analises/curva-mortalidade/", {
                        params: params
                    })
                    let respTecnico = context.listRegistrosExtensionista.find(x => x.cdResponsavelTecnico == cdResponsavelTecnico)
                    if (response.data[0].data != null)
                    {
                        if (cdResponsavelTecnico) {
                            if (respTecnico) {
                                respTecnico.registrosMortalidadeGrafico[item.text] = response.data[0].data
                            }
                            else {
                                let newRespTecnico = {
                                    cdResponsavelTecnico: cdResponsavelTecnico,
                                    nmResponsavelTecnico: context.technicalManagers.find(x => x.idResponsavelTecnico == cdResponsavelTecnico).nmPessoa,
                                    registrosMortalidadeGrafico: {}
                                }
                                newRespTecnico.registrosMortalidadeGrafico[item.text] = response.data[0].data
                                context.listRegistrosExtensionista.push(newRespTecnico)
                            }
                            if (respTecnico.selected.length == Object.keys(respTecnico.registrosMortalidadeGrafico).length)
                            {
                                context.exibeGrafico = true
                            }
                        }
                        else
                        {
                            respTecnico.registrosMortalidadeGrafico[item.text] = response.data[0].data
                            if (respTecnico.selected.length == Object.keys(respTecnico.registrosMortalidadeGrafico).length)
                            {
                                context.exibeGrafico = true
                            }
                        }
                        context.isLoading = false
                    }
                    else
                    {
                        if (cdResponsavelTecnico != 0) {
                            context.$store.commit('setSnack', {type: 'alert', msg : 'Nenhuma informação encontrada para o extensionista ' + respTecnico.nmResponsavelTecnico + ' no mês ' + item.text + '.'})    
                        }
                        else {
                            context.$store.commit('setSnack', {type: 'alert', msg : 'Nenhuma informação encontrada para o mês ' + item.text + '.'})
                        }
                        var indexResp = context.listRegistrosExtensionista.indexOf(respTecnico)
                        var index = respTecnico.selected.indexOf(item)
                        context.removeItemSelection(indexResp, index)
                        context.isLoading = false
                    }
                } 
                catch (error) 
                {
                    context.exibeGrafico = false
                    context.$store.commit('setSnack', {type: 'error', msg : error})
                }
            }
        },
        initViewFromRoute() {
            this.$store.dispatch('actLoadTabelasMetaMortalidade')
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' () {
            this.initViewFromRoute()
        },
        'dtMesFechamento' (newValue) {
            if (newValue)
            {
                this.selectedMonthChange(newValue)
            }
        }
    },
    mounted() {
        this.initViewFromRoute()
        this.listTechnicalManagers()
    },
}
</script>